$(->

  # TODO: brittany@careerplug.com 10/4 - These deal with not-Canaan's report builder.
  # Seems likely these will therefore be stale once new reports are on main production.

  # Shows/hides correct reports fields when changing reports tabs 

  $('#report_params_report_type').change(->
    $('fieldset.report_fields select, fieldset.report_fields input').prop('disabled', true)
    $('fieldset.report_fields').hide()
    active_selector = 'fieldset.report_fields.' + $(this).val()
    $(active_selector).show()
    $(active_selector + ' select, ' + active_selector + ' input').prop('disabled', false)
  ).change()
  

  # Checks all boxes when any Enable/Disable All box in reports is checked

  $('input.select_all').change ->
    $(this).closest('fieldset').find('input[type=checkbox]').prop('checked', $(this).is(':checked'))

  # Source Detail tabs under Source Analysis report type

  $('.chart-switch a[data-toggle="tab"]').on 'shown.bs.tab', (e)->
    $('#new_report input#current_tab').val($(e.target).attr('href').replace('#', ''))
)
